import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from '../../../core/i18n';
import { config } from '../../../config';

import {
  Button,
  Container,
  Content,
  DownloadContainer,
  HelpMessage,
  Image,
  TutorialLink,
  Typography,
  DownloadLink,
} from './styles';

const MAC_URL_DOWNLOAD = config.REACT_APP_MAC_URL_DOWNLOAD;
const WINDOWS_URL_DOWNLOAD = config.REACT_APP_WINDOWS_URL_DOWNLOAD;
const WINDOWS_MS_URL_DOWNLOAD = config.REACT_APP_WINDOWS_MS_STORE_URL;
const TUTORIAL_URL = 'https://www.playbookux.com/download-instructions/';

const Download = (props) => {
  const { phrases } = props;

  // get os from window.navigator
  const os = window.navigator.platform;

  const handleOpenTutorial = () => {
    window.open(TUTORIAL_URL, '_blank');
  };

  const handleMacDownloadClicked = () => {
    window.location.href = MAC_URL_DOWNLOAD;
  };

  const handleWindowsDownloadClicked = () => {
    if (os === 'Win32' || os === 'Windows' || os === 'Win64') {
      window.location.href = WINDOWS_MS_URL_DOWNLOAD;
    } else {
      window.location.href = WINDOWS_URL_DOWNLOAD;
    }
  };

  const handleCodeSignedWindowsDownload = () => {
    window.location.href = WINDOWS_URL_DOWNLOAD;
  };

  return (
    <Container>
      <Typography>{phrases.tester_unmoderated_session_heading}</Typography>

      <Content>
        <DownloadContainer>
          <Image src="../../images/macos-icon.png" />

          <Button onClick={handleMacDownloadClicked}>
            {phrases.mac_download_button}
          </Button>
        </DownloadContainer>

        <DownloadContainer>
          <Image src="../../images/windows-icon.png" />

          <Button onClick={handleCodeSignedWindowsDownload}>
            {phrases.windows_download_button}
          </Button>

          <DownloadLink onClick={handleWindowsDownloadClicked}>
            Install from the Windows Store
          </DownloadLink>
        </DownloadContainer>
      </Content>

      <HelpMessage>
        {phrases.getting_started_video_1}
        <TutorialLink onClick={handleOpenTutorial}>
          {` ${phrases.getting_started_video_2} `}
        </TutorialLink>
        {phrases.getting_started_video_3}
      </HelpMessage>
    </Container>
  );
};

Download.propTypes = {
  phrases: PropTypes.shape({
    getting_started_video_1: PropTypes.string,
    getting_started_video_2: PropTypes.string,
    getting_started_video_3: PropTypes.string,
    tester_unmoderated_session_heading: PropTypes.string,
    mac_download_button: PropTypes.string,
    windows_download_button: PropTypes.string,
  }).isRequired,
};

export default withTranslation(Download);
